module.exports = __webpack_public_path__ + "static/img/NZ.b0712fce.png";